"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-event-prices {\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  align-self: flex-start; }\n  .sia-event-prices .text-container {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 16px;\n    row-gap: 0px; }\n";
  const fileName = "SIAinFormEventPrices_SIAinFormEventPrices";
  const element = document.querySelector("style[data-sass-component='SIAinFormEventPrices_SIAinFormEventPrices']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAinFormEventPrices = _ref => {
  let {
    event_price
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-event-prices"
  }, event_price.map((el, index) => /*#__PURE__*/_react.default.createElement("div", {
    className: "text-container sia-text-08 sia-margin-01-bottom",
    key: index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "price"
  }, el.price_name.name, ":"), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, "CHF ", el.price_value, ".\u2013"))));
};
var _default = exports.default = SIAinFormEventPrices;